import { PaperGradientBG } from "../kits";

const sections = [
  {
    cmd: "privacy --general",
    label: "01 allgemeines",
    content: "Der Schutz deiner Daten ist mir wichtig. Diese Seite informiert dich darueber, wie ich mit personenbezogenen Daten umgehe, wenn du meine Website besuchst, mich kontaktierst oder einen Kurs anfragst.",
  },
  {
    cmd: "privacy --owner",
    label: "02 verantwortlich",
    lines: [
      "Denis Bitter",
      "e-mail: saghallo@denisbitter.de",
    ],
    emailIndex: 1,
  },
  {
    cmd: "privacy --collected",
    label: "03 welche daten werden erfasst",
    list: [
      "Name, E-Mail und Nachricht bei Kontaktaufnahme",
      "Auswahl deines Kurswunsches (z.B. Programm, Kategorie, Freitext)",
      "Nutzungsdaten (z.B. Browser, Bildschirmgroesse, IP-Adresse in anonymisierter Form)",
    ],
  },
  {
    cmd: "privacy --purpose",
    label: "04 zweck der verarbeitung",
    content: "Wir nutzen deine Daten ausschliesslich, um:",
    list: [
      "deine Anfrage zu beantworten",
      "dir passende Inhalte vorzuschlagen",
      "mein Angebot zu verbessern (z.B. welche Interessen gefragt sind)",
    ],
  },
  {
    cmd: "privacy --thirdparty",
    label: "05 drittanbieter",
    content: "Ich setze auf Drittanbieter, um bestimmte Funktionen und Inhalte bereitzustellen:",
    list: [
      "YouTube & Vimeo: Fuer das Abspielen von eingebetteten Videos. Beim Aufruf kann deine IP-Adresse an die Anbieter uebertragen werden.",
      "E-Mail-Dienstleister: Wenn du dich zu einem Newsletter anmeldest, nutze ich ggf. Anbieter wie Mailchimp oder Sendinblue. Dabei werden deine Kontaktdaten dort gespeichert.",
    ],
    footer: "Diese Anbieter handeln in unserem Auftrag gemaess Art. 28 DSGVO (Auftragsverarbeitung). Es gelten deren Datenschutzrichtlinien.",
  },
  {
    cmd: "privacy --hosting",
    label: "06 hosting",
    content: "Meine Website wird bei einem europaeischen Hostinganbieter betrieben. Dabei werden technische Daten wie IP-Adresse und Zeitstempel erfasst, um die Seite auszuliefern und abzusichern. Es findet keine Weitergabe dieser Daten an Dritte statt.",
    list: [
      "Anbieter: IONOS SE, Elgendorfer Str. 57, 56410 Montabaur",
      "Datenverarbeitung erfolgt innerhalb der EU",
      "Auftragsverarbeitungsvertrag gemaess Art. 28 DSGVO",
    ],
  },
  {
    cmd: "privacy --retention",
    label: "07 speicherdauer",
    content: "Ich speichere deine Daten nur so lange, wie es fuer die Bearbeitung deiner Anfrage notwendig ist. Danach werden sie geloescht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.",
  },
  {
    cmd: "privacy --rights",
    label: "08 deine rechte",
    list: [
      "Auskunft ueber gespeicherte Daten",
      "Berichtigung, Loeschung oder Einschraenkung",
      "Widerruf deiner Einwilligung",
      "Beschwerde bei einer Datenschutzbehoerde",
    ],
  },
  {
    cmd: "privacy --contact",
    label: "09 kontakt",
    content: "Wenn du Fragen zum Datenschutz hast oder wissen moechtest, welche Daten ich ueber dich gespeichert habe, schreib mir gerne:",
    email: "saghallo@denisbitter.de",
  },
];

export default function Datenschutz() {
  return (
    <PaperGradientBG variant="zenBlack">
      <div className="min-h-screen flex items-start justify-center px-4 py-20">
        <div className="w-full max-w-2xl">

          {/* Terminal: datenschutz */}
          <div className="border border-[#AC8E66]/20 rounded-lg overflow-hidden">
            {/* Title bar */}
            <div className="flex items-center gap-2 px-4 py-2 bg-[#1a1a1a]">
              <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
              <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
              <span className="w-3 h-3 rounded-full bg-[#28c840]" />
              <span className="ml-3 text-[#EFEBDC]/40 text-xs font-mono">datenschutz</span>
            </div>

            {/* Terminal body */}
            <div className="p-6 sm:p-8 space-y-8 font-mono text-xs">

              {/* Main command */}
              <div>
                <span className="text-[#AC8E66]">$</span>
                <span className="text-[#EFEBDC]/90 ml-2">legal --datenschutz</span>
              </div>

              {/* Sections */}
              {sections.map((s, i) => (
                <div key={i} className="space-y-2">
                  {/* Section command */}
                  <div className="text-[#EFEBDC]/40">
                    <span className="text-[#AC8E66]/50">$</span>
                    <span className="ml-2">{s.cmd}</span>
                  </div>

                  {/* Label */}
                  <p className="text-[#AC8E66]/80 text-[10px] uppercase tracking-widest">{s.label}</p>

                  {/* Content paragraph */}
                  {s.content && (
                    <p className="text-[#EFEBDC]/70 leading-relaxed">
                      <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                      {s.content}
                    </p>
                  )}

                  {/* Lines (for address-like blocks) */}
                  {s.lines && s.lines.map((line, j) => (
                    <p key={j} className="text-[#EFEBDC]/70">
                      <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                      {s.emailIndex === j ? (
                        <>
                          e-mail:{" "}
                          <a href="mailto:saghallo@denisbitter.de" className="text-[#AC8E66] hover:text-[#AC8E66]/80 transition-colors">
                            saghallo@denisbitter.de
                          </a>
                        </>
                      ) : line}
                    </p>
                  ))}

                  {/* List items */}
                  {s.list && (
                    <div className="space-y-1 pl-1">
                      {s.list.map((item, j) => (
                        <p key={j} className="text-[#EFEBDC]/70 leading-relaxed">
                          <span className="text-[#AC8E66]/40 mr-2">•</span>
                          {item}
                        </p>
                      ))}
                    </div>
                  )}

                  {/* Footer text */}
                  {s.footer && (
                    <p className="text-[#EFEBDC]/50 leading-relaxed pt-1">
                      <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                      {s.footer}
                    </p>
                  )}

                  {/* Email link */}
                  {s.email && (
                    <p className="text-[#EFEBDC]/70 pt-1">
                      <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                      <a href={`mailto:${s.email}`} className="text-[#AC8E66] hover:text-[#AC8E66]/80 transition-colors">
                        {s.email}
                      </a>
                    </p>
                  )}
                </div>
              ))}

              {/* Stand */}
              <p className="text-green-400/70 text-[10px] pt-2">
                # stand: mai 2025
              </p>

            </div>
          </div>

        </div>
      </div>
    </PaperGradientBG>
  );
}
